module.exports = __webpack_public_path__ + "media/images/new/mobile/icons/arrow_up-22e46a747661356a5bf1cefe32b9d1f9.png";